<template>
    <section class="waitlist">
        <div class="userBlock"
            v-if="users.length > 0 && !loading">
            <ul class="users">
                <li class="user"
                    v-for="(user, index) in users"
                    :key="index">
                    <div class="userDetail">
                        <Heading :h="4" size="s">
                            {{ user.name }}
                        </Heading>
                        <span class="email">
                            {{ user.email }}
                        </span>
                        <a class="portfolio"
                            :href="user.portfolio">
                            {{ user.portfolio }}
                        </a>
                    </div>
                    <div class="tag">
                        {{ user.interest[0] }}
                    </div>
                    <Button class="select"
                        size="fullWidth"
                        appearance="secondary"
                        @click="changeSelected(user)">
                        Select user
                    </Button>
                    <Button class="delete"
                        size="fullWidth"
                        appearance="red"
                        @click="deleteUser(user)">
                        Delete user
                    </Button>
                </li>
            </ul>
        </div>
        <Heading :h="2">
            Register
        </Heading>
        <Register
            :selectedUser="selectedUser"/>
    </section>
</template>

<script>
    import { db } from '@/firebase'

    import Register from '@/components/login/Register'

    export default {
        name: 'WaitlistInvite',
        components: {
            Register
        },
        props: {
            content: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                users: [],
                selectedUser: {
                    email: '',
                    username: '',
                    password: Math.random().toString(36).slice(-8),
                }
            }
        },
        mounted() {
            this.fetchWaitlist()
        },
        methods: {
            async fetchWaitlist() {
                try {
                    await db
                        .collection('waitlist')
                        .orderBy('timestamp', 'desc')
                        .onSnapshot(snapshot => {
                            const users = snapshot.docs
                            .map(doc => {
                                return { 
                                    id: doc.id,
                                    ...doc.data()
                                }
                            })
                            
                        this.users = users

                        return () => cleanUp()
                    })

                    this.loading = false
                } catch(error) {
                    throw error
                }
            },
            changeSelected(u) {
                this.selectedUser.email = u.email
                this.selectedUser.username = u.name
            },
            async deleteUser(u) {
                try {
                    await db
                        .collection('waitlist')
                        .doc(u.id)
                        .delete()

                    this.$toasted.show('User successfully deleted.')
                } catch(error) {
                    throw error
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .waitlist {
        display: flex;
        flex-direction: column;
    }

    .userBlock {
        display: flex;
        width: 100%;
    }

    .users {
        display: flex;
        margin: 0 0 2rem 0;
        padding: 0 0 1rem 0;
        width: 100%;
        overflow-x: auto;
    }

    .user {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0.75rem 1.5rem;
        border-radius: 1rem;
        background: var(--color-grey-150);
        list-style: none;
        margin: 0 1rem 0 0;
        min-width: 16rem;
    }

    .portfolio {
        font-size: 1rem;
    }

    .userDetail {
        display: flex;
        flex-direction: column;
        margin-bottom: 0.75rem;
    }

    .h4 {
        margin: 0;
    }

    .email {
        font-size: 1rem;
        color: var(--color-grey-600);
        word-break: break-all;
    }

    .tag {
        display: flex;
        width: fit-content;
        background: var(--color-white-40);
        border-radius: 0.5rem;
        padding: 0.5rem 1rem;
        font-size: 0.875rem;
        font-weight: 600;
        margin-bottom: 1rem;
    }

    .select {
        margin-bottom: 0.5rem;
    }
</style>